import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// local components
import FundsPageTemplate from '../components/fundsPageTemplate';
import VariableProductsFootnotes from '../components/variableProductsFootnotes';
// data
import fundData from '../_fundData/fundData';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();
  const disclaimer = VariableProductsFootnotes();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      customDisclaimers={[disclaimer]}
      disableDisclaimerTopBorder>
      <FundsPageTemplate pageProps={pageProps} copy={fundData.index500StockFund} />
    </Page>
  );
};
